<template>
  <div>
    <div v-if="Object.keys(userById).length === 0">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      <h2>Dane</h2>
      <h5>
        {{
          userById.user_profile.profile.is_employee_profile_verified
            ? "Profil zweryfikowany"
            : "Profil niezweryfikowany"
        }}
      </h5>
      <button
        v-if="!userById.user_profile.profile.is_employee_profile_verified"
        type="button"
        class="btn btn-outline-dark btn-sm"
        @click="changeStatus('ACCEPTED')"
        style="margin-bottom: 20px"
      >
        Oznacz jako profil zweryfikowany
      </button>
      <button
        v-if="userById.user_profile.profile.is_employee_profile_verified"
        type="button"
        class="btn btn-outline-dark btn-sm"
        @click="changeStatus('REJECTED')"
        style="margin-bottom: 20px"
      >
        Oznacz jako profil niezweryfikowany
      </button>

      <button
        v-if="
          userById.user_profile.profile.payment_verification_status !==
          'ACCEPTED'
        "
        type="button"
        class="btn btn-outline-dark btn-sm"
        @click="changePaymentVerificationStatus('ACCEPTED')"
        style="margin-bottom: 20px; margin-left: 20px"
      >
        Oznacz konto bankowe jako zweryfikowane
      </button>
      <div class="" style="padding: 0px !important">
        <table
          class="table borderless"
          v-if="userById.user_profile && userById.user_profile.profile"
        >
          <thead>
            <tr class="tr-table">
              <th scope="col">ID</th>
              <th scope="col">Data ostatniej decyzji weryfikacji</th>
              <th scope="col">Status konta</th>
              <th scope="col">Imie</th>
              <th scope="col">Nazwisko</th>
              <th scope="col">Zdjęcie</th>
              <th scope="col">Bio</th>
              <th scope="col">Pesel</th>
              <th scope="col">Adresy użytkownika</th>
              <th scope="col">Promień świadczenia usług</th>
              <th scope="col">Numer konta bankowego</th>
              <th scope="col">Czy konto bankowe zweryfikowane?</th>
              <th scope="col">Email</th>
              <th scope="col">Czy email zweryfikowany?</th>
              <th scope="col">Status zatrudnienia</th>
              <th scope="col">Nazwa firmy</th>
              <th scope="col">NIP</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ userById.user_profile.user.id }}</td>
              <td>
                {{
                  userById.user_profile.profile
                    .date_of_last_verification_decision
                    ? formattedDate(
                        userById.user_profile.profile
                          .date_of_last_verification_decision
                      )
                    : "Brak"
                }}
              </td>
              <td>{{ userById.user_profile.profile.employee_status }}</td>
              <td>{{ userById.user_profile.profile.first_name }}</td>
              <td>{{ userById.user_profile.profile.last_name }}</td>
              <td>
                <a
                  target="_blank"
                  :href="
                    getUrl() +
                    '/api/profile/photo/' +
                    userById.user_profile.profile.file_path
                  "
                >
                  <img
                    class="img-avatar"
                    :src="
                      getUrl() +
                      '/api/profile/photo/' +
                      userById.user_profile.profile.file_path
                    "
                  />
                </a>
              </td>
              <td style="min-width: 300px">
                {{ userById.user_profile.profile.note }}
              </td>
              <td>{{ userById.user_profile.profile.pesel }}</td>
              <td>
                <button
                  type="button"
                  class="btn btn-outline-dark"
                  data-toggle="modal"
                  :data-target="`#address${userById.user_profile.user.id}`"
                >
                  Pokaż
                </button>
              </td>
              <td>
                {{ userById.user_profile.profile.distance }}km <br />
                <button
                  data-toggle="modal"
                  data-target="#addNewSms"
                  class="form-item btn btn-outline-dark"
                >
                  Edytuj
                </button>
              </td>
              <td>{{ userById.user_profile.profile.account_number }}</td>
              <td>
                {{
                  userById.user_profile.profile.payment_verification_status ===
                  "ACCEPTED"
                    ? "Tak"
                    : "Nie"
                }}
              </td>
              <td>{{ userById.user_profile.profile.email }}</td>
              <td>
                {{
                  userById.user_profile.profile.is_email_verified === "true"
                    ? "Tak"
                    : "Nie"
                }}
              </td>
              <td>{{ userById.user_profile.profile.profile_status }}</td>
              <td>
                {{
                  userById.user_profile.profile.company_name
                    ? userById.user_profile.profile.company_name
                    : "Brak"
                }}
              </td>
              <td>
                {{
                  userById.user_profile.profile.company_nip
                    ? userById.user_profile.profile.company_nip
                    : "Brak"
                }}
              </td>
              <!-- Adresy użytkownika -->
              <div
                class="modal fade"
                :id="`address${userById.user_profile.user.id}`"
                tabindex="-1"
                role="dialog"
                aria-labelledby="address"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-xl" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="address">
                        Adresy użytkownika
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        @click="changes = null"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <h4>Adres do faktury</h4>
                      <table class="table modal-table">
                        <thead>
                          <tr class="tr-table">
                            <th scope="col">Kod pocztowy</th>
                            <th scope="col">Miasto</th>
                            <th scope="col">Ulica</th>
                            <th scope="col">Numer budynku</th>
                            <th scope="col">Numer mieszkania</th>
                            <th scope="col">Piętro</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>
                              {{
                                userById.user_profile.profile.postcode_invoice
                                  ? userById.user_profile.profile
                                      .postcode_invoice
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.city_invoice
                                  ? userById.user_profile.profile.city_invoice
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.street_invoice
                                  ? userById.user_profile.profile.street_invoice
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.number1_invoice
                                  ? userById.user_profile.profile
                                      .number1_invoice
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.number2_invoice
                                  ? userById.user_profile.profile
                                      .number2_invoice
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.floor_invoice
                                  ? userById.user_profile.profile.floor_invoice
                                  : "Brak"
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <h4>Adres świadczenia usług</h4>
                      <table class="table modal-table">
                        <thead>
                          <tr class="tr-table">
                            <th scope="col">Kod pocztowy</th>
                            <th scope="col">Miasto</th>
                            <th scope="col">Ulica</th>
                            <th scope="col">Numer budynku</th>
                            <th scope="col">Numer mieszkania</th>
                            <th scope="col">Piętro</th>
                            <th scope="col">Latitude</th>
                            <th scope="col">Longitude</th>
                            <th scope="col">Promień</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>
                              {{
                                userById.user_profile.profile.employee_postcode
                                  ? userById.user_profile.profile
                                      .employee_postcode
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.employee_city
                                  ? userById.user_profile.profile.employee_city
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.employee_street
                                  ? userById.user_profile.profile
                                      .employee_street
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.employee_number1
                                  ? userById.user_profile.profile
                                      .employee_number1
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.employee_number2
                                  ? userById.user_profile.profile
                                      .employee_number2
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.employee_floor
                                  ? userById.user_profile.profile.employee_floor
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.employee_latitude
                                  ? userById.user_profile.profile
                                      .employee_latitude
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.employee_longitude
                                  ? userById.user_profile.profile
                                      .employee_longitude
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.distance
                                  ? userById.user_profile.profile.distance
                                  : "Brak"
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <span
                        v-if="
                          userById.user_profile.profile.distance &&
                          userById.user_profile.profile.postcode
                        "
                      >
                        Promień świadczenia usług:
                        {{ userById.user_profile.profile.distance }}km
                      </span>

                      <h4 class="mt-10">Adres użytkownika</h4>
                      <table class="table modal-table">
                        <thead>
                          <tr class="tr-table">
                            <th scope="col">Kod pocztowy</th>
                            <th scope="col">Miasto</th>
                            <th scope="col">Ulica</th>
                            <th scope="col">Numer budynku</th>
                            <th scope="col">Numer mieszkania</th>
                            <th scope="col">Piętro</th>
                            <th scope="col">Latitude</th>
                            <th scope="col">Longitude</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td>
                              {{
                                userById.user_profile.profile.postcode
                                  ? userById.user_profile.profile.postcode
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.city
                                  ? userById.user_profile.profile.city
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.street
                                  ? userById.user_profile.profile.street
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.number1
                                  ? userById.user_profile.profile.number1
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.number2
                                  ? userById.user_profile.profile.number2
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.floor
                                  ? userById.user_profile.profile.floor
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.latitude
                                  ? userById.user_profile.profile.latitude
                                  : "Brak"
                              }}
                            </td>
                            <td>
                              {{
                                userById.user_profile.profile.longitude
                                  ? userById.user_profile.profile.longitude
                                  : "Brak"
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-outline-dark"
                        data-dismiss="modal"
                        @click="changes = null"
                      >
                        Zamknij
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </tr>
          </tbody>
        </table>
      </div>

      <h5
        v-if="
          userById.user_profile.user.employees &&
          userById.user_profile.user.employees.length > 0
        "
        class="mt-6"
      >
        Pracownicy konta biznesowego
      </h5>
      <div
        v-if="
          userById.user_profile.user.employees &&
          userById.user_profile.user.employees.length > 0
        "
        class=""
        style="padding: 0px !important"
      >
        <table
          class="table borderless"
          v-if="userById.user_profile && userById.user_profile.profile"
        >
          <thead>
            <tr class="tr-table">
              <th scope="col">ID</th>
              <th scope="col">Identyfikator</th>
              <th scope="col">Imie</th>
              <th scope="col">Nazwisko</th>
              <th scope="col">Zdjęcie</th>
              <th scope="col">Bio</th>
              <th scope="col">Profil</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="employee in userById.user_profile.user.employees"
              :key="employee.id"
            >
              <td>{{ employee.user.id }}</td>
              <td>
                {{ employee.user.phone }}
              </td>
              <td>{{ employee.profile.first_name }}</td>
              <td>{{ employee.profile.last_name }}</td>
              <td>
                <a
                  target="_blank"
                  :href="
                    getUrl() +
                    '/api/profile/photo/' +
                    employee.profile.file_path
                  "
                >
                  <img
                    class="img-avatar"
                    :src="
                      getUrl() +
                      '/api/profile/photo/' +
                      employee.profile.file_path
                    "
                  />
                </a>
              </td>
              <td>{{ employee.profile.note }}</td>
              <td>
                <router-link
                  :to="{
                    path: '/users/id/' + employee.user.id,
                  }"
                >
                  <button
                    type="button"
                    class="btn btn-outline-dark mr-3"
                    @click="getUser(employee.user.id)"
                  >
                    Przejdź
                  </button>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Dane do faktury -->
      <InvoiceDataSection
        v-if="userById && userById.user_profile"
        :profile="userById.user_profile.profile"
        :userId="userById.user_profile.user.id"
        @updated="getUserData"
      />

      <h2 v-if="reasons && reasons.length > 0">
        Historia odrzuceń weryfikacji
      </h2>
      <table class="table table-striped" v-if="reasons && reasons.length > 0">
        <thead>
          <tr class="tr-table">
            <th scope="col">Data odrzucenia</th>
            <th scope="col">Powód</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="reason in this.reasons" :key="reason.id">
            <td>{{ formattedDate(reason.creationDate) }}</td>
            <td>{{ reason.message }}</td>
          </tr>
        </tbody>
      </table>

      <div
        v-if="
          userById.user_profile.profile.cv &&
          userById.user_profile.profile.cv.profile_id
        "
      >
        <h3>CV do pobrania</h3>
        <button
          class="btn btn-sm btn-outline-dark downloadButton"
          @click="
            downloadEmployeeCv(userById.user_profile.profile.cv.profile_id)
          "
        >
          Pobierz
        </button>
      </div>

      <div
        v-if="
          userById.user_profile.profile.trainings &&
          userById.user_profile.profile.trainings.length > 0
        "
      >
        <h2>Szkolenia</h2>
        <table
          class="table borderless"
          v-if="
            userById.user_profile &&
            userById.user_profile.profile &&
            userById.user_profile.profile.trainings &&
            userById.user_profile.profile.trainings.length > 0
          "
        >
          <thead>
            <tr class="tr-table">
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(training, index) in userById.user_profile.profile
                .trainings"
              :key="`${training.main_value}_${index}`"
            >
              <td>{{ training.main_value }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        v-if="
          userById.user_profile.profile.languages &&
          userById.user_profile.profile.languages.length > 0
        "
      >
        <h2>Języki</h2>
        <table
          class="table borderless"
          v-if="
            userById.user_profile &&
            userById.user_profile.profile &&
            userById.user_profile.profile.languages &&
            userById.user_profile.profile.languages.length > 0
          "
        >
          <thead>
            <tr class="tr-table">
              <th scope="col">Język</th>
              <th scope="col">Poziom</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(language, index) in userById.user_profile.profile
                .languages"
              :key="`${language.main_value}_${index}`"
            >
              <td>{{ language.language_name }}</td>
              <td>{{ translateLanguage(language.detail) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        v-if="
          userById.user_profile.profile.vacations &&
          userById.user_profile.profile.vacations.length > 0
        "
      >
        <h2>Nieobecności</h2>
        <table
          class="table borderless"
          v-if="
            userById.user_profile &&
            userById.user_profile.profile &&
            userById.user_profile.profile.vacations &&
            userById.user_profile.profile.vacations.length > 0
          "
        >
          <thead>
            <tr class="tr-table">
              <th scope="col">Od</th>
              <th scope="col">Do</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="vacation in userById.user_profile.profile.vacations"
              :key="vacation.vacation_id"
            >
              <td>{{ vacation.start }}</td>
              <td>{{ vacation.end }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        v-if="
          userById.user_profile.profile.languages &&
          userById.user_profile.profile.languages.length > 0
        "
      >
        <h2>Więcej o użytkowniku</h2>
        <table
          class="table borderless"
          v-if="
            userById.user_profile &&
            userById.user_profile.profile &&
            userById.user_profile.profile.features &&
            userById.user_profile.profile.features.length > 0
          "
        >
          <thead>
            <tr class="tr-table">
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(feature, index) in userById.user_profile.profile.features"
              :key="`${feature}_${index}`"
            >
              <td>
                {{ feature.detail }}
                <span
                  v-if="
                    isHealthFeature(feature) &&
                    !userById.user_profile.profile.health_data_consent
                  "
                  class="text-muted"
                  >(niewidoczne dla innych)</span
                >
              </td>
            </tr>
          </tbody>
        </table>
        <p v-if="userById.user_profile && userById.user_profile.profile">
          Zgoda na dane o zdrowiu:
          <strong>{{
            healthConsentLabel(userById.user_profile.profile)
          }}</strong>
        </p>
      </div>
      <employee-services
        :userById="userById"
        @servicesUpdated="servicesUpdated"
      />
    </div>
    <div class="comission">
      <h5
        style="padding-left: 5px"
        v-if="userById.user_profile && userById.user_profile.profile"
      >
        <template v-if="isUserCommissionExpired">
          Prowizja dla użytkownika
          {{ userById.user_profile.profile.first_name }} wynosi:
          {{ defaultCommission !== null ? defaultCommission : "..." }} %
          (prowizja domyślna)
        </template>
        <template v-else>
          Prowizja dla użytkownika
          {{ userById.user_profile.profile.first_name }} wynosi:
          {{ userById.user_profile.user.commission * 100 }} %
          <br />
          <span
            v-if="userById && userById.user_profile.user.commission_valid_date"
            >Ważna do
            {{
              formattedDateWithoutTime(
                userById.user_profile.user.commission_valid_date
              )
            }}</span
          >
        </template>
      </h5>

      <div class="commission-container">
        <form class="topform" @submit.prevent="changeCommissionHandler()">
          <div v-if="userCommissionMessage" class="text-danger">
            {{ userCommissionMessage }}
          </div>
          <div>
            <label style="flex: 0 0 auto; margin: 0px"
              >Prowizja w procentach</label
            >
            <input
              v-model="commission"
              id="name"
              type="number"
              class="form-control"
              required
              minlength="1"
              min="0"
              max="100"
              step="1"
            />
            <label style="flex: 0 0 auto; margin: 0px"
              >Data ważności prowizji</label
            >
            <datepicker
              :monday-first="true"
              :language="pl"
              v-model="commission_valid_date"
              name="commissionDate"
              :placeholder="'Wybierz datę'"
              :disabledDates="{ to: new Date() }"
              required
            ></datepicker>
          </div>
          <button class="form-item btn btn-outline-dark" type="submit">
            Zmień
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
//import axios from "../axios";
import shared from "../shared";
import { URL } from "../axios";
import axios from "../axios";
import EmployeeServices from "../components/EmployeeServices.vue";
import InvoiceDataSection from "../components/InvoiceDataSection.vue";
import Datepicker from "vuejs-datepicker";
import { pl } from "vuejs-datepicker/dist/locale";
export default {
  components: { EmployeeServices, InvoiceDataSection, Datepicker },
  name: "EmployeeProfile",
  data: function () {
    return {
      reasons: [],
      formattedDateWithoutTime: null,
      formattedDate: null,
      commission: 0,
      commission_valid_date: null,
      pl: pl,
    };
  },
  computed: {
    userCommissionMessage() {
      return this.$store.getters.getUserCommissionMessage;
    },
    isUserCommissionExpired() {
      const validDate = this.userById?.user_profile?.user?.commission_valid_date;
      if (!validDate) {
        return false;
      }
      // Spójnie z backendem (UserServiceService): prowizja użytkownika obowiązuje
      // tylko, gdy data ważności jest w przyszłości - po jej upływie liczy się domyślna.
      return new Date(validDate).getTime() <= Date.now();
    },
    defaultCommission() {
      return this.$store.getters.getCurrentCommission;
    },
    userById() {
      return this.$store.getters.getUserById;
    },
    ratings() {
      return this.$store.getters.getAddedRatings;
    },
  },
  async created() {
    this.formattedDateWithoutTime = shared.formattedDateWithoutTime;
    this.formattedDate = shared.formattedDate;
    this.$store.dispatch("getCurrentDefaultCommission", {});
    await this.getUserData();
    this.$store.dispatch("fetchAddedRatings", {
      user_id: this.$route.params.id,
    });
    this.getReasons();
  },
  methods: {
    isHealthFeature(feature) {
      return shared.isHealthFeature(
        this.userById.user_profile.profile,
        feature
      );
    },
    healthConsentLabel(profile) {
      return shared.healthConsentLabel(profile);
    },
    async changeCommissionHandler() {
      if (!this.commission_valid_date) {
        return this.$notify({
          group: "error",
          text: "Wybierz datę ważności prowizji",
        });
      }
      await this.$store.dispatch("changeUserCommission", {
        userId: this.$route.params.id,
        commission: this.commission / 100,
        commission_valid_date: shared.dateWithoutTimeToString(
          this.commission_valid_date
        ),
      });
      this.commission_valid_date = null;
      this.commission = 0;
      // $emit("servicesUpdated") szedł do nieistniejącego rodzica - profil (w tym
      // wyświetlana prowizja) nie odświeżał się po zapisie bez przeładowania strony.
      await this.getUserData();
    },
    servicesUpdated() {
      console.log("servicesUpdated");
      this.getUserData();
    },
    downloadEmployeeCv(cvId) {
      let url = `api/admin/cv-download/${cvId}`;

      axios(url, {
        method: "GET",
        headers: {
          "Content-Disposition": "attachment; filename=reports.xls",
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "blob",
      })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", cvId + "_cv.pdf");
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((err) => console.log(err.response));
    },

    translateLanguage(language) {
      if (language === "BASIC") {
        return "podstawowy";
      } else if (language === "INTERMEDIATE") {
        return "śr. zaawansowany";
      } else {
        return "zaawansowany";
      }
    },
    changePaymentVerificationStatus(status) {
      const confirmed = prompt(
        `Czy na pewno oznaczyć numer konta jako zweryfikowany? Potwierdź wpisując 'ZWERYFIKOWANE'`,
        ""
      );
      if (confirmed === "ZWERYFIKOWANE") {
        axios
          .put(
            `/api/profile/${this.userById.user_profile.user.id}/paymentVerificationStatus?status=${status}`
          )
          .then(() => {
            this.getUserData();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    async changeStatus(employee_status) {
      try {
        const confirmMessage =
          employee_status === "ACCEPTED" ? "ZWERYFIKOWANY" : "NIEZWERYFIKOWANY";
        const confirmed = prompt(
          `Czy na pewno zmienić status opiekuna na ${confirmMessage}? Potwierdź wpisując '${confirmMessage}'`,
          ""
        );

        if (confirmed === confirmMessage) {
          axios
            .put(
              `/api/profile/changeStatusWithoutMessage/${this.$route.params.id}?employee_status=${employee_status}`
            )
            .then(() => {
              if (employee_status === "REJECTED") {
                this.$notify({
                  group: "success",
                  text: "Pomyślnie odrzucono użytkownika!",
                });
                this.getUserData();
              } else {
                this.$notify({
                  group: "success",
                  text: "Pomyślnie zaakceptowano użytkownika!",
                });
                this.getUserData();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } catch (err) {
        console.log(err);
        this.$notify({
          group: "success",
          text: "Nie udało się zmienić statusu użytkownika",
        });
      }
    },

    getReasons() {
      axios
        .get(`/api/reasonRejectedEmployee/user/${this.$route.params.id}/`)
        .then((response) => {
          this.reasons = response.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getUser(id) {
      this.$store.dispatch("fetchUserByPhoneOrUserId", {
        param: id,
      });
    },

    getUrl() {
      return URL;
    },
    async getUserData() {
      this.$store.dispatch("getUserById", {
        userId: this.$route.params.id,
      });
    },
  },
};
</script>

<style scoped>
.mt-10 {
  margin-top: 30px;
}

.topform {
  width: 300px;
}
.topform input {
  width: 300px;
}
/* Datepicker to komponent potomny - scoped ".topform input" nie obejmuje jego
   wnętrza, stąd głębokie selektory. Jawny blok 300px bez marginesów wyrównuje
   pole 1:1 z inputem "Prowizja w procentach". */
.topform >>> .vdp-datepicker {
  width: 300px;
  margin: 0;
}
.topform >>> .vdp-datepicker input {
  display: block;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
}
.commission-container {
  text-align: center;
  display: flex;
  justify-content: center;
  width: 300px;
  margin: 0 auto;
}
</style>
